export class Notification {
  id: string;
  userCode: string;
  type: string;
  title: string;
  description: string;
  date: string;
  readIndicator: boolean; //#555
  actionLink: string;
  isStatic: boolean;
  expiration: Date;
  constructor() {
    this.id = ('L' + (Math.floor((Math.random() * 9000) + 1)));
    this.userCode = "";
    this.type = "";
    this.title="Alerta de sistema"
    this.description = ""
    this.date = "";
    this.date = "";
    this.readIndicator = false;
    this.actionLink = "";
    this.isStatic = false;
    this.expiration = new Date();
  }
}

export class ResponseMessage {
  MessageCode: string;
  Message: string;
  ExceptionMessage: string;
  MessageType: number;
  OperationId: number;
  isStatic: string;
}
